import { render, staticRenderFns } from "./UtilisateurMenu.vue?vue&type=template&id=4e489155&scoped=true&"
import script from "./UtilisateurMenu.vue?vue&type=script&lang=js&"
export * from "./UtilisateurMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e489155",
  null
  
)

export default component.exports